import React from 'react';
import { Button, Select } from 'src/@vymo/ui/atoms';
import Input from 'src/@vymo/ui/atoms/input';
import { Popup, RangePicker } from 'src/@vymo/ui/blocks';
import { ReactComponent as CloseIcon } from 'src/assets/icons/close.svg';
import { envUrls, STATUS_OPTIONS } from './constants';
import { PlaybookTrackerFiltersProps } from './types';
import styles from './index.module.scss';

function PlaybookTrackerFiltersBar({
  filters,
  loading,
  customEnvUrl,
  onInputChange,
  onStatusChange,
  onStatusClearClick,
  onDateRangeChange,
  onCustomEnvUrlChange,
  onCustomEnvAdd,
  onEnvSelect,
  onSearch,
  onReset,
}: PlaybookTrackerFiltersProps) {
  return (
    <div className={styles.playbookTracker__filters}>
      <Popup
        placement="bottom"
        closeTrigger="outside"
        popupClass={styles.playbookTracker__envPopup}
        content={
          <div className={styles.playbookTracker__envPopupContent}>
            <div className={styles.playbookTracker__envList}>
              {envUrls.map((envOption) => (
                <button
                  type="button"
                  key={envOption.url}
                  className={styles.playbookTracker__envOption}
                  onClick={() => onEnvSelect(envOption.name, envOption.url)}
                  data-test-id={`playbook-tracker-env-${envOption.name}`}
                >
                  {envOption.name}
                </button>
              ))}
            </div>
            <div className={styles.playbookTracker__envCustomInput}>
              <Input
                value={customEnvUrl}
                onChange={onCustomEnvUrlChange}
                placeholder="Add custom env URL"
                data-test-id="playbook-tracker-custom-env-input"
              />
              <Button
                onClick={onCustomEnvAdd}
                data-test-id="playbook-tracker-custom-env-add"
              >
                Add
              </Button>
            </div>
          </div>
        }
      >
        <Button
          className={styles.playbookTracker__envTrigger}
          data-test-id="playbook-tracker-env-trigger"
        >
          {filters.envLabel || 'Select env'}
        </Button>
      </Popup>
      <Input
        value={filters.clientId}
        onChange={onInputChange('clientId')}
        placeholder="Search by client id"
        data-test-id="playbook-tracker-lead-filter"
      />
      <div className={styles.playbookTracker__statusFilter}>
        <Select
          value={filters.status ? [filters.status] : []}
          onChange={onStatusChange}
          options={STATUS_OPTIONS}
          placeholder="Search by status"
          data-test-id="playbook-tracker-lead-filter"
        />
        {filters.status && !loading ? (
          <button
            type="button"
            className={styles.playbookTracker__statusClearIcon}
            onClick={onStatusClearClick}
            data-test-id="playbook-tracker-status-clear"
            aria-label="Clear status filter"
          >
            <CloseIcon />
          </button>
        ) : null}
      </div>
      <Input
        value={filters.recordId}
        onChange={onInputChange('recordId')}
        placeholder="Search by lead id"
        data-test-id="playbook-tracker-lead-filter"
      />
      <Input
        value={filters.playbookCode}
        onChange={onInputChange('playbookCode')}
        placeholder="Search by playbook code"
        data-test-id="playbook-tracker-playbook-code-filter"
      />
      <RangePicker
        value={filters.dateRange}
        onChange={(value) => onDateRangeChange(value as [Date, Date])}
        placeholderText={{ start: 'Start date', end: 'End date' }}
        data-test-id="playbook-tracker-date-filter"
      />
      <div className={styles.playbookTracker__actions}>
        <Button
          type="primary"
          onClick={onSearch}
          disabled={loading}
          data-test-id="playbook-tracker-search"
        >
          Search
        </Button>
        <Button
          onClick={onReset}
          disabled={loading}
          data-test-id="playbook-tracker-reset"
        >
          Reset
        </Button>
      </div>
    </div>
  );
}

export default PlaybookTrackerFiltersBar;
